<template>
  <v-card class="px-4 date-filter-card">
    <v-layout row wrap align-baseline>
      <v-flex>
        <v-icon small class="mr-2">filter_list</v-icon>
        <b>PERIOD</b>
        <!-- <v-chip small outline color="secondary" class="ml-4" @click="selectInterval('today')">Today</v-chip> -->
        <v-chip
          small
          :outline="selected !== '1m'"
          :color="selected !== '1m' ? '' : 'accent'"
          :text-color="selected !== '1m' ? '' : 'white'"
          class="ml-4"
          @click="selectInterval('1m')"
        >1m</v-chip>
        <v-chip
          small
          :outline="selected !== '2m'"
          :color="selected !== '2m' ? '' : 'accent'"
          :text-color="selected !== '2m' ? '' : 'white'"
          class="ml-1"
          @click="selectInterval('2m')"
        >2m</v-chip>
        <v-chip
          small
          :outline="selected !== '3m'"
          :color="selected !== '3m' ? '' : 'accent'"
          :text-color="selected !== '3m' ? '' : 'white'"
          class="ml-1"
          @click="selectInterval('3m')"
        >3m</v-chip>
      </v-flex>
      <v-flex>
        <v-dialog
          ref="fromDialog"
          v-model="fromDateModal"
          :return-value.sync="fromDate"
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on" @click="selected = ''" class="custom-date-selector">
              <span class="custom-date-label">From</span>
              <v-icon small class="mr-1">today</v-icon>
              <span v-if="fromDate">
                {{ fromDate }}
                <v-icon small class="ml-1">edit</v-icon>
              </span>
              <span v-else>Select date</span>
            </div>
          </template>
          <v-date-picker v-model="fromDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.fromDialog.save(fromDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex>
        <v-dialog ref="toDialog" v-model="toDateModal" :return-value.sync="toDate" width="290px">
          <template v-slot:activator="{ on }">
            <div v-on="on" @click="selected = ''" class="custom-date-selector">
              <span class="custom-date-label">To</span>
              <v-icon small class="mr-1">today</v-icon>
              <span v-if="toDate">
                {{ toDate }}
                <v-icon small class="ml-1">edit</v-icon>
              </span>
              <span v-else>Select date</span>
            </div>
          </template>
          <v-date-picker v-model="toDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.toDialog.save(toDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
	name: 'DateFilter',
	created () {
		let to = new Date()
		let from = new Date(to.getTime() - (30 * 24 * 60 * 60 * 1000))
		this.fromDate = (new Date(from)).toISOString().split('T')[0]
		setTimeout(() => {
      this.toDate = (new Date(to)).toISOString().split('T')[0]
    }, 1)
		this.selected = '1m'
	},
	watch: {
		'fromDate' (value) {
			if (this.toDate !== '') {
				this.setDateRange(value, this.toDate)
			}
		},
		'toDate' (value) {
			if (this.fromDate !== '') {
				this.setDateRange(this.fromDate, value)
			}
		}
	},
	data () {
		return {
			selected: '',
      fromDate: '',
      toDate: '',
      fromDateModal: false,
      toDateModal: false
		}
	},
	methods: {
		selectInterval (interval) {
			let to = new Date()
			let from = new Date(to.getTime() - (30 * 24 * 60 * 60 * 1000))
			if (interval === '1m') {
				this.selected = '1m'
				from = new Date(to.getTime() - (30 * 24 * 60 * 60 * 1000))
			}
			else if (interval === '2m') {
				this.selected = '2m'
				from = new Date(to.getTime() - (60 * 24 * 60 * 60 * 1000))
			}
			else if (interval === '3m') {
				this.selected = '3m'
				from = new Date(to.getTime() - (90 * 24 * 60 * 60 * 1000))
			}

			this.toDate = (new Date(to)).toISOString().split('T')[0]
			this.fromDate = (new Date(from)).toISOString().split('T')[0]
		},
		setDateRange () {
			const to = Math.round((new Date(this.toDate)).getTime() / 1000)
      const from = Math.round((new Date(this.fromDate)).getTime() / 1000)
			const period = (to - from) > (86400 * 59) ? (30 * 24 * 60 * 60) : (24 * 60 * 60)
			this.$emit('date:changed', { to, from, period })
		}
	}
}
</script>

<style scoped>
.date-filter-card {
  padding-top: 24px
}

.custom-date-selector {
  background: #f7f7f7;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  padding: 3px;
  text-align: center
}

.custom-date-label {
	display: inline-block;
	font-size: 12px;
	font-weight: 700;
	margin-right: 6px;
	text-transform: uppercase !important
}
</style>
